<div class="flex flex-col w-full h-full">
  <div class="flex flex-col gap-10 justify-center items-center mb-8">
    <p class="text-light-300 text-3xl font-medium text-center">
      Investement confirmed
    </p>
    <p class="max-w-xl text-center text-light-300">
      An email confirmation including information about your investement and the
      property will be sent to you shorty.
    </p>

    <p-button
      severity="primary"
      label="View my portfolio"
      size="small"
      fluid="true"
      (onClick)="onViewPortfolio()"
    />

    <div
      class="flex flex-row items-center justify-between gap-2 border border-light-180 rounded-lg p-3 w-full"
    >
      <h3 class="font-medium text-base text-light-300">
        Total investment amount
      </h3>

      <span class="font-bold text-xl text-light-300">
        {{ totalInvestedAmount | customCurrency : currency }}
      </span>
    </div>
  </div>

  <div class="flex flex-col gap-6 w-full pb-8">
    @for (item of investedItems; track $index) {
    <p-card [style]="{ overflow: 'auto' }">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col sm:flex-row gap-5">
          <img
            class="rounded-lg h-20 w-32 object-cover"
            [src]="item.property.images[0].url"
            [alt]="item.property.images[0].caption"
          />

          <div class="flex flex-row gap-3 w-full justify-between">
            <div class="flex flex-col gap-3 w-full">
              <h2 class="font-bold text-base text-light-300">
                {{ item.property.name }}
              </h2>

              <div class="flex flex-col sm:flex-row gap-4 sm:gap-20">
                <div class="flex flex-row sm:flex-col gap-1 justify-between">
                  <div class="flex flex-row gap-1 items-center text-light-100">
                    <svg-icon src="assets/icons/info.svg" svgClass="h-4 w-4" />
                    <p class="font-medium text-sm">Monthly rent</p>
                  </div>

                  <p class="font-bold text-sm text-light-300">
                    {{ item.monthlyCashflow | customCurrency : currency }}
                  </p>
                </div>

                <div class="flex flex-row sm:flex-col gap-1 justify-between">
                  <div class="flex flex-row gap-1 items-center text-light-100">
                    <svg-icon src="assets/icons/info.svg" svgClass="h-4 w-4" />
                    <p class="font-medium text-sm">Appreciation</p>
                  </div>

                  <p class="font-bold text-sm text-light-300">
                    {{ item.property.appreciation | customCurrency : currency }}
                  </p>
                </div>

                <div class="flex flex-row sm:flex-col gap-1 justify-between">
                  <div class="flex flex-row gap-1 items-center text-light-100">
                    <p class="font-medium text-sm">Investment amount</p>
                  </div>

                  <p class="font-bold text-sm text-light-300">
                    {{ item.amount | customCurrency : currency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
    }
  </div>
</div>
